import { COLOR } from '../data/colors.data'
import { AUTHORIZATION_STATUS } from '../model/auth-status'

const statusColors = {
  [AUTHORIZATION_STATUS.NONE]: COLOR.DEFAULT,
  [AUTHORIZATION_STATUS.INITIATED_CASE_MEDICAL]: COLOR.YELLOW,
  [AUTHORIZATION_STATUS.INITIATED_CASE_INSURANCE]: COLOR.YELLOW,
  [AUTHORIZATION_STATUS.CONTACT_PAYER]: COLOR.FLASHING_YELLOW,
  [AUTHORIZATION_STATUS.DENIED]: COLOR.FLASHING_RED,
  [AUTHORIZATION_STATUS.PEER_REVIEW]: COLOR.YELLOW,
  [AUTHORIZATION_STATUS.INELIGIBLE]: COLOR.FLASHING_RED,
  [AUTHORIZATION_STATUS.NO_ACTION_REQUIRED]: COLOR.FLASHING_GREEN,
  [AUTHORIZATION_STATUS.EXPIRED]: COLOR.RED,
  [AUTHORIZATION_STATUS.PARTIALLY_APPROVED]: COLOR.FLASHING_GREEN,
  [AUTHORIZATION_STATUS.CANCELLED]: COLOR.DEFAULT,
  [AUTHORIZATION_STATUS.COMPLETED]: COLOR.GREEN,
  [AUTHORIZATION_STATUS.APPROVED]: COLOR.GREEN,
}

// Ordered from highest priority to lowest
export const AUTHORIZATION_STATUS_PRIORITY: AUTHORIZATION_STATUS[] = [
  AUTHORIZATION_STATUS.CONTACT_PAYER,
  AUTHORIZATION_STATUS.DENIED,
  AUTHORIZATION_STATUS.INELIGIBLE,
  AUTHORIZATION_STATUS.PARTIALLY_APPROVED,
  AUTHORIZATION_STATUS.PEER_REVIEW,
  AUTHORIZATION_STATUS.EXPIRED,
  AUTHORIZATION_STATUS.NONE,
  AUTHORIZATION_STATUS.INITIATED_CASE_MEDICAL,
  AUTHORIZATION_STATUS.INITIATED_CASE_INSURANCE,
  AUTHORIZATION_STATUS.APPROVED,
  AUTHORIZATION_STATUS.COMPLETED,
  AUTHORIZATION_STATUS.NO_ACTION_REQUIRED,
]

export const getWorstAuthorizationStatus = (
  statuses: AUTHORIZATION_STATUS[] = [],
): AUTHORIZATION_STATUS => {
  if (!statuses.length) {
    return AUTHORIZATION_STATUS.NONE
  }

  for (const status of AUTHORIZATION_STATUS_PRIORITY) {
    if (statuses.includes(status)) {
      return status
    }
  }

  return AUTHORIZATION_STATUS.NONE
}

export const getAuthorizationStatusText = (
  status: AUTHORIZATION_STATUS = AUTHORIZATION_STATUS.NONE,
): string => {
  return `statuses.authorizations.${status}`
}

export const getAuthorizationStatusColor = (
  status: AUTHORIZATION_STATUS = AUTHORIZATION_STATUS.NONE,
): COLOR => {
  return statusColors[status]
}

export const getWorstAuthorizationStatusColor = (statuses: AUTHORIZATION_STATUS[]): COLOR => {
  if (!statuses.length) {
    return getAuthorizationStatusColor()
  }

  return getAuthorizationStatusColor(getWorstAuthorizationStatus(statuses))
}

export const getWorstAuthorizationStatusText = (statuses: AUTHORIZATION_STATUS[]): string => {
  if (!statuses.length) {
    return getAuthorizationStatusText()
  }

  return getAuthorizationStatusText(getWorstAuthorizationStatus(statuses))
}
